import ComponentModule from "@eisinc/Overrides/Components/ShareListModal";

export * from "@eisinc/Overrides/Components/ShareListModal";

export default ComponentModule;
